<template>
  <div class="collectief-geheugen">
    <transition name="fade" mode="out-in" :appear="true">
      <play-video
        v-if="state === 0"
        :youtubeId="activeQuestion.video.youtubeId"
        :infoText="activeQuestion.question"
        :start="activeQuestion.video.start"
        :end="activeQuestion.video.end"
      >
      </play-video>
      <play-screen v-else></play-screen>
    </transition>
  </div>
</template>

<script>
import PlayVideo from '@/components/elements/playVideo';
import PlayScreen from './playScreen';

export default {
  name: 'collectief-geheugen',
  components: { PlayVideo, PlayScreen },
  computed: {
    state() {
      return this.$store.state.rounds.collectiefGeheugen.state;
    },
    activeQuestion() {
      return this.$store.getters['collectiefGeheugen/activeQuestion'];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
